import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorBannerProps {
  message: string;
  className?: string;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, className = '' }) => (
  <div
    role="alert"
    className={`flex items-start gap-2 rounded-xl bg-red-100 p-4 text-sm text-red-700 ring-1 ring-red-300 dark:bg-red-900/25 dark:text-red-300 dark:ring-red-500/40 ${className}`}
  >
    <AlertCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
    <span>{message}</span>
  </div>
);

export default ErrorBanner;
